import styled from 'styled-components';

//Imports from IOSE components
import IoseSideCard from 'components/IoseSideCard';

export const Container = styled(IoseSideCard)`
  padding: 16px;
  background: none;
`;
